import { Divider, FormControl, FormLabel, Input, ModalBody, ModalFooter, Select, Switch } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import SubmitButton from 'components/ui/SubmitButton';
import { useContentGroup } from 'features/content-groups/hooks/useContentGroup';
import { useMessages } from 'hooks/useMessages';
import { FormProvider, Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import TemplateCategory from 'types/entities/template-category.entity';
import * as Yup from 'yup';
import { useTemplateCategoriesContext } from '../contexts/TemplateCategoriesContext';
import { CategoryInputs, useSaveTemplateCategory } from '../hooks/useSaveTemplateCategory';

interface FormSubcategoryProps {
  category?: TemplateCategory
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  contentGroupId: Yup.string().required(),
  parentId: Yup.string().required(),  
});

export default function FormSubcategory({ category }: FormSubcategoryProps) {
  const { modals, state: { parentCategory } } = useTemplateCategoriesContext();
  const { id } = useParams();
  const { data: contentGroup } = useContentGroup(id);

  const defaultValues: CategoryInputs = {
    name: category?.name || '',
    contentGroupId: id as string,
    parentId: parentCategory?.id,
    active: category?.active
  };

  const methods = useForm<CategoryInputs>({
    mode: 'all',
    resolver: yupResolver(validationSchema) as Resolver<CategoryInputs>,
    defaultValues
  });

  const { register, watch, handleSubmit, reset, formState: { errors, isValid } } = methods;

  const [isActive] = watch(['active']);

  const { onError } = useMessages();

  const { 
    onSaveTemplateCategory, 
    isPending,
  } = useSaveTemplateCategory({ 
        categoryId: category?.id,
        contentGroupId: id as string,
        onSuccess: () => {
          reset();
          modals.subcategory.onClose();
        },
        onError: (error) => onError(error?.response?.data?.message)
      });
    
  const onSubmit: SubmitHandler<CategoryInputs> = (data) => onSaveTemplateCategory(data);
  
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody minH="400px">
          <FormControl isInvalid={!!errors.name} isRequired>
            <FormLabel>Nome</FormLabel>
            <Input {...register('name')} />
          </FormControl>

        { category && (
          <FormControl isInvalid={!!errors.active}>
            <FormLabel>Status</FormLabel>
            <Switch {...register('active')}>
            { isActive ? 'Ativo' : 'Inativo' }
            </Switch>
          </FormControl>
        ) }

          <Divider my="38px" />

          <FormControl>
            <FormLabel>Modelo de disparo</FormLabel>
            <Select disabled>
              <option value={id}>{contentGroup?.name}</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Categoria</FormLabel>
            <Select disabled>
              <option value={parentCategory?.id}>{parentCategory?.name}</option>
            </Select>
          </FormControl>
        </ModalBody>  
        <ModalFooter>
          <SubmitButton 
            isDisabled={isPending || !isValid}
            isLoading={isPending}
            hideIcon
          >
            { category ? 'Alterar' : 'Adicionar' }
          </SubmitButton>
        </ModalFooter>
      </form>
    </FormProvider>
  )
}
